<template>
  <v-text-field
    v-model="inputValue"
    prepend-inner-icon="fa-light fa-search"
    variant="outlined"
    class="search-bar-input"
    :class="{ desktop: !$vuetify.display.xs }"
    :bg-color="bgColor"
    hide-details
    density="comfortable"
    placeholder="Meklēt Somā"
    @keydown.enter="submit"
  >
  </v-text-field>
</template>

<script>
import { useSearchStore } from "~/stores/searchStore"

export default {
  props: {
    insideDrawer: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  setup() {
    const searchStore = useSearchStore()
    return { searchStore }
  },

  data() {
    return {
      inputValue: this.searchStore.query || "",
    }
  },

  computed: {
    bgColor() {
      return this.insideDrawer ? "rgba(0, 0, 0, 0.04)" : "grayBack"
    },
  },

  watch: {
    "searchStore.query"(newQuery) {
      this.inputValue = newQuery
    },
  },

  methods: {
    submit() {
      if (!this.inputValue.trim()) {
        return
      }

      this.searchStore.search(this.inputValue)
      navigateTo({ path: "/search", query: { query: this.inputValue } })
    },
  },
}
</script>

<style lang="sass">
.search-bar-input
  min-width: 226px
  &.desktop
    max-width: 226px

  .v-field__outline
    --v-field-border-width: 0

  .v-field__prepend-inner .v-icon
    font-size: 20px
</style>
